// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useState} from 'react';
import cn from 'classnames';

import Icon_chevron_down from '../../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import styles from './order_summary.module.less';
import {use_theme} from '../../../../../hola/pub/settings_ctx';
import {t_periods} from '../../../types';

type t_order_summary_props = {
    cls?: string;
    product_type: string;
    is_isp?: boolean;
    is_isp_plus?: boolean;
    total: number;
    package_gb: number;
    period: t_periods;
    ips_amount?: number | undefined;
};

const PERIOD_TO_PLAN: Record<t_periods, string> = {
    '1m': 'Monthly',
    '1y': 'Yearly',
    '1w': 'Weekly',
    '1d': 'Dayly',
    '3m': 'Quarterly',
};

export const Order_summary=({cls, is_isp, is_isp_plus, total, package_gb,
    period, product_type, ips_amount}: t_order_summary_props)=>{
    const {theme} = use_theme();
    const [show, set_show] = useState(false);
    const plan = PERIOD_TO_PLAN[period];
    const per_gb_cost = (total / package_gb).toFixed(2);
    const per_ip_cost = (total / ips_amount).toFixed(2);
    const summary_cls = cn(cls, styles.order, !show && styles.closed,
        is_isp && styles.is_isp);
    const is_rotating_resi = product_type == 'Rotating Residential Proxies';
    return <div className={summary_cls}>
      <button className={styles.header} onClick={()=>set_show(x=>!x)}>
        <p className={cn(theme.P, theme.med)}>Order summary</p>
        <Icon_chevron_down className={styles.arrow}/>
      </button>
      <div className={styles.features}>
        <div className={styles.feature}>
          <p className={cn(styles.feature_label, theme.p14)}>
            Product type</p>
          <p className={cn(theme.p14, theme.med)}>{product_type}</p>
        </div>
        {!is_rotating_resi && <Fragment>
          <div className={styles.feature}>
            <p className={cn(styles.feature_label, theme.p14)}>
              Total proxies</p>
            <div className={styles.feature_value}>
              <p className={cn(theme.p14, theme.med)}>{ips_amount}</p>
              <p className={cn(theme.p14, theme.med, theme.color_n400)}>
                (${per_ip_cost} per proxy)
              </p>
            </div>
          </div>
          <div className={styles.feature}>
            <p className={cn(styles.feature_label, theme.p14)}>
              Bandwidth</p>
            <p className={cn(theme.p14, theme.med)}>
              {is_isp ? 'Unlimited' : `Up to ${package_gb}GB`}
            </p>
          </div>
        </Fragment>}
        {is_rotating_resi && <div className={styles.feature}>
          <p className={cn(styles.feature_label, theme.p14)}>
            Package size</p>
          <div className={styles.feature_value}>
            <p className={cn(theme.p14, theme.med)}>{package_gb}GB</p>
            <p className={cn(theme.p14)}>(${per_gb_cost} per GB)</p>
          </div>
        </div>}
        {is_isp_plus && <div className={styles.feature}>
          <p className={cn(styles.feature_label, theme.p14)}>
            Scrape Search Engines</p>
          <div className={styles.feature_value}>
            <p className={cn(theme.p14, theme.med)}>US only</p>
          </div>
        </div>}
        <div className={styles.feature}>
          <p className={cn(styles.feature_label, theme.p14)}>
            Plan duration</p>
          <p className={cn(theme.p14, theme.med)}>{plan}</p>
        </div>
      </div>
      <p className={cn(styles.total, theme.P, theme.med)}>
        <span>Total</span>
        <span id={'total_value'}>${total}</span>
      </p>
    </div>;
};
